import { render } from "./tricking-trampoline.vue?vue&type=template&id=3048c35b"
import script from "./tricking-trampoline.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./tricking-trampoline.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "/home/th3g3ntl3man/github/blog/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__